import React from "react";
import moment from "moment";

// hooks
import { useParams } from "react-router";
import usePlan from "../../common/apollo/hooks/usePlan";

// components
import Layout from "../../components/Layout";
import Loader from "../../common/loader";
import Error from "../../common/error";
import Plan from "./Plan";
import DateNavigation from "./DateNavigation";

const Home = () => {
  const { date: routeDate } = useParams();
  const dateFormat = "yyyy-MM-DD";

  let selectedDate = null;
  if (routeDate) {
    selectedDate = moment(routeDate);
    selectedDate = selectedDate.isValid() ? selectedDate : null;
  }

  if (!selectedDate) selectedDate = moment();

  const {
    data: plan = [],
    loading,
    error,
  } = usePlan(selectedDate.format(dateFormat));

  return (
    <Layout title={<DateNavigation />}>
      {loading && <Loader message="Loading plan" />}
      {!loading && error && <Error error={error} />}
      {!loading && !error && <Plan data={plan} date={selectedDate} />}
    </Layout>
  );
};

export default Home;
